import { cn } from '@/utils/classname';
import { exploreLayout } from './ExploreLayout';

export const MobileTabBar = () => {
  const tabs = exploreLayout.tabs.useValue();
  const currentTab = exploreLayout.currentTab.useValue();

  if (currentTab === null) return null;
  return (
    <div className="sticky bottom-0 flex bg-neutral-200 px-2 pb-1">
      {tabs.map(tab => {
        const isCurrentTab = tab === currentTab;

        return (
          <div
            className={cn(
              'grid grid-rows-[auto_auto] grid-cols-1 cursor-pointer self-center justify-items-center gap-1 p-2 w-16 transition-background-color,border-radius duration-200',
              isCurrentTab && 'bg-neutral-100 rounded-b-2',
            )}
            key={tab.id}
            onClick={() => exploreLayout.switchTab(tab)}
          >
            <span className={cn('text-20px color-neutral-600 w-20px h-20px', tab.iconClass)} />
            <span className="color-neutral-600 typo-text-xxs">{tab.title}</span>
          </div>
        );
      })}
    </div>
  );
};
